'use strict';
const translations = {
    en: {
        'title.1': 'KAT VR | No.1 VR Treadmill Technology Innovator',
        'option.1': 'En',
        'option.2': 'Ua',
        'option.3': 'De',
        'a.1': 'About',
        'a.2': 'Tech',
        'a.3': 'Benefits',
        'a.4': 'Contact',
        'a.5': 'Language',
        'a.6': 'FAQ',
        'a.7': 'Help',
        'li.1': 'English',
        'li.2': 'Ukrainian',
        'li.3': 'Deutsche',
        'h2.1': 'HOW CAN WE ',
        'span.1': 'HELP ',
        'span.101': 'YOU?',
        'p.1': 'Welcome to our help center. Our goal is to make the process of getting acquainted and purchase as easy and pleasant as possible. Need help with your KAT VR loco product? Many product questions can be resolved by reviewing our Product Support. ',
        'a.8': 'FAQs',
        'p.2': "Please also feel free to  directly should you need anything further. We\u2019re happy to help. ",
        'a.9': 'Contact Us',
        'a.10': 'Instruction manual',
        'a.11': 'Where to go for a warranty',
        'a.12': 'Service Policy',
        'a.13': '+86-0571-86105373',
        'a.14': 'global@katvr.com',
        'a.15': 'overseas@katvr.com',
        'h1.1': 'THE NEW START OF',
        'span.2': 'VR LOCOMOTION',
        'p.3': 'Discover the most comprehensive VR Locomotion system, and unlock\n            infinite motion in any games on any platforms!',
        'p.4': '1200$',
        'p.5': 'Play Video',
        'button.1': 'Buy now',
        'button.2': 'More',
        'h2.2': 'MORE THAN',
        'span.3': 'GAMING!',
        'p.6': 'This also made for people who are interested in...',
        'h3.1': 'EDUCATION',
        'p.7': 'Create aducational simulations, trainings and much more with',
        'span.4': '...',
        'span.5': 'unlimited virtual space and minimum physical space',
        'h3.2': 'REAL ESTATE',
        'p.8': 'Design architectural projects in a deeply realistic environment',
        'span.6': '...',
        'span.7': 'allowing visitors to freely walk around, and feel their vibe',
        'h3.3': 'FITNESS',
        'p.9': 'Combine business with pleasure, and discover countless ways',
        'span.8': '...',
        'span.9': 'to stay fit while playing your favorite VR Games!',
        'h3.4': 'SOCIAL INTERACTIONS',
        'p.10': "Hang out with your friends in the virtual world when you can\u2019t",
        'span.10': '...',
        'span.11': 'meet space requirements',
        'h2.3': 'ABOUT',
        'span.12': 'PRODUCT',
        'div.1': '1/5',
        'div.2': '2/5',
        'div.3': '3/5',
        'div.4': '4/5',
        'div.5': '5/5',
        'button.3': 'Previous',
        'button.4': 'Next',
        'div.6': 'KAT loco is a foot-based VR locomotion system that gives complete \n          physical control over lower-body actions, allowing you to freely walk,\n          run, and carry out just any other movement in virtual reality.',
        'p.11': 'Play Video',
        'div.7': 'Hello,',
        'h2.4': 'NICE TO MEET',
        'span.13': 'YOU!',
        'div.8': "KAT VR is an independent company dedicated to the research, \n          development, and sales of VR Locomotion products and solutions.\n          Founded in 2013, we have quickly grown to become one of the world\u2019s\n          leading professional suppliers of VR games\u2019 & simulations\u2019 equipment",
        'h2.5': 'TECH',
        'span.14': 'SPECS',
        'h3.5': 'SENSOR',
        'p.12': 'Weight: 35g/1.23oz each  \n    Dimension: 50mm/1.97in 24mm/0.94in  \n    Light: LED lights',
        'h3.6': 'CONNECTION',
        'p.13': 'Wireless: Bluetooth 4.2  \n    Signal range: 5m  \n   Receiver: USB 2.0 and above',
        'h3.7': 'BATTERIES',
        'p.14': 'Type: Lithium-ion polymer batteries \n      Capacity: 370mAh   \n   Battery life: 10h of continuous use 150 hours on stand by \n     Charging: Fast charging - 1 hour \n     Charging voltage and current: 5V = 0.5A',
        'h2.6': 'WHY',
        'span.15': 'KAT LOCO?',
        'h3.8': 'UNIVERSALLY COMPATIBLE',
        'p.15': 'KAT Loco offers universal compatibility across all major VR headsets and',
        'span.16': 'platforms...',
        'span.17': '...',
        'span.18': 'platforms allowing you to play any VR game with support for   Free Locomotion',
        'h3.9': 'VR/PC CONTROL PANEL',
        'p.16': "Our Multifunctional Software allows for quick access to KAT Loco\u2019s",
        'span.19': 'control panel both from...',
        'span.20': '...',
        'span.21': 'control panel both from a computer desktop, and directly   from your VR headset.',
        'h3.10': 'WIRELESS SENSORS',
        'p.17': 'What makes it even more advanced, KAT Loco is entirely wireless, and',
        'span.22': 'comes with a...',
        'span.23': '...',
        'span.24': 'comes with a complete system of algorithms, super durable   batteries and more!',
        'button.5': 'Buy now',
        'p.18': 'Have any questions?',
        'h2.7': 'GET IN',
        'span.25': 'TOUCH',
        'p.19': 'Our manager will reply you within 15 minutes',
        'a.16': '+86-0571-86105373',
        'a.17': 'global@katvr.com',
        'a.18': 'overseas@katvr.com',
        'label.1': 'Name*',
        'label.2': 'Email*',
        'label.3': 'Phone*',
        'label.4': 'Message',
        'a.19': 'About',
        'a.20': 'Tech',
        'a.21': 'Benefits',
        'a.22': 'Contact',
        'a.23': '+86-0571-86105373',
        'a.24': 'global@katvr.com',
        'a.25': 'overseas@katvr.com'
    },
    ua: {
        'title.1': "KAT VR | \u041D\u043E\u0432\u0430\u0442\u043E\u0440 \u21161 \u0443 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0456\u0457 VR \u0434\u043E\u0440\u0456\u0436\u043E\u043A",
        'option.1': 'En',
        'option.2': 'Ua',
        'option.3': 'De',
        'a.1': "\u041F\u0440\u043E \u043D\u0430\u0441",
        'a.2': "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0456\u0457",
        'a.3': "\u041F\u0435\u0440\u0435\u0432\u0430\u0433\u0438",
        'a.4': "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
        'a.5': "\u041C\u043E\u0432\u0430",
        'a.6': "\u0427\u0430\u041F\u0438",
        'a.7': "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
        'li.1': "\u0410\u043D\u0433\u043B\u0456\u0439\u0441\u044C\u043A\u0430",
        'li.2': "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        'li.3': "\u041D\u0456\u043C\u0435\u0446\u044C\u043A\u0430",
        'h2.1': "\u042F\u041A \u041C\u0418  \u041C\u041E\u0416\u0415\u041C\u041E ",
        'span.1': "\u0414\u041E\u041F\u041E\u041C\u041E\u0413\u0422\u0418 ",
        'span.101': "\u0412\u0410\u041C?",
        'p.1': "\u041B\u0430\u0441\u043A\u0430\u0432\u043E \u043F\u0440\u043E\u0441\u0438\u043C\u043E \u0434\u043E \u043D\u0430\u0448\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0443 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438. \u041D\u0430\u0448\u0430 \u043C\u0435\u0442\u0430 \u2014 \u0437\u0440\u043E\u0431\u0438\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441 \u043E\u0437\u043D\u0430\u0439\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0442\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u043F\u0440\u043E\u0441\u0442\u0438\u043C \u0456 \u043F\u0440\u0438\u0454\u043C\u043D\u0438\u043C. \u041F\u043E\u0442\u0440\u0435\u0431\u0443\u0454\u0442\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0438 \u0437 \u0432\u0430\u0448\u0438\u043C \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u043C KAT VR loco? \u0411\u0430\u0433\u0430\u0442\u043E \u043F\u0438\u0442\u0430\u043D\u044C \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u0440\u0456\u0448\u0438\u0442\u0438, \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0432\u0448\u0438 \u043D\u0430\u0448\u0443 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438. ",
        'a.8': "\u0427\u0430\u041F\u0438",
        'p.2': "\u0422\u0430\u043A\u043E\u0436 \u043D\u0435 \u0441\u043E\u0440\u043E\u043C\u0442\u0435\u0441\u044F \u0437\u0432\u0435\u0440\u0442\u0430\u0442\u0438\u0441\u044F \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E, \u044F\u043A\u0449\u043E \u0432\u0430\u043C \u0437\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u044C\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430. \u041C\u0438 \u0440\u0430\u0434\u0456 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. ",
        'a.9': "\u0417\u0432\u2019\u044F\u0437\u0430\u0442\u0438\u0441\u044F \u0437 \u043D\u0430\u043C\u0438",
        'a.10': "\u0406\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u044F",
        'a.11': "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
        'a.12': "\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0430 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
        'a.13': '+86-0571-86105373',
        'a.14': 'global@katvr.com',
        'a.15': 'overseas@katvr.com',
        'h1.1': "\u041D\u041E\u0412\u0418\u0419 \u041F\u041E\u0427\u0410\u0422\u041E\u041A",
        'span.2': 'VR LOCOMOTION',
        'p.3': "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0434\u043B\u044F \u0441\u0435\u0431\u0435 \u043D\u0430\u0439\u043F\u043E\u0432\u043D\u0456\u0448\u0443 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 VR Lokomotion \u0442\u0430 \u0440\u043E\u0437\u0431\u043B\u043E\u043A\u0443\u0439\u0442\u0435 \u043D\u0435\u0441\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u0456 \u0440\u0443\u0445\u0438 \u0443 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0445 \u0456\u0433\u0440\u0430\u0445 \u043D\u0430 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0445 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u0445!",
        'p.4': '1200$',
        'p.5': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0456\u0434\u0435\u043E",
        'button.1': "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u0440\u0430\u0437",
        'button.2': "\u0411\u0456\u043B\u044C\u0448\u0435",
        'h2.2': "\u0411\u0406\u041B\u042C\u0428\u0415 \u041D\u0406\u0416",
        'span.3': "\u0413\u0415\u0419\u041C\u0406\u041D\u0413!",
        'p.6': "\u0426\u0435 \u0442\u0430\u043A\u043E\u0436 \u0434\u043B\u044F \u0442\u0438\u0445, \u043A\u043E\u0433\u043E \u0446\u0456\u043A\u0430\u0432\u0438\u0442\u044C...",
        'h3.1': "\u041E\u0421\u0412\u0406\u0422\u0410",
        'p.7': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u043E\u0441\u0432\u0456\u0442\u043D\u0456 \u0441\u0438\u043C\u0443\u043B\u044F\u0446\u0456\u0457, \u0442\u0440\u0435\u043D\u0456\u043D\u0433\u0438 \u0442\u0430 \u0431\u0430\u0433\u0430\u0442\u043E \u0456\u043D\u0448\u043E\u0433\u043E \u0437",
        'span.4': '...',
        'span.5': "\u043D\u0435\u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0438\u043C \u0432\u0456\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0438\u043C \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u043E\u043C \u0456 \u043C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u043E\u044E \u0444\u0456\u0437\u0438\u0447\u043D\u043E\u044E \u043F\u043B\u043E\u0449\u0435\u044E",
        'h3.2': "\u041D\u0415\u0420\u0423\u0425\u041E\u041C\u0406\u0421\u0422\u042C",
        'p.8': "\u041F\u0440\u043E\u0435\u043A\u0442\u0443\u0439\u0442\u0435 \u0430\u0440\u0445\u0456\u0442\u0435\u043A\u0442\u0443\u0440\u043D\u0456 \u043F\u0440\u043E\u0435\u043A\u0442\u0438 \u0432 \u043D\u0430\u0434\u0437\u0432\u0438\u0447\u0430\u0439\u043D\u043E \u0440\u0435\u0430\u043B\u0456\u0441\u0442\u0438\u0447\u043D\u043E\u043C\u0443 \u0441\u0435\u0440\u0435\u0434\u043E\u0432\u0438\u0449\u0456",
        'span.6': '...',
        'span.7': "\u0434\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0447\u0438 \u0432\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u0447\u0430\u043C \u0432\u0456\u043B\u044C\u043D\u043E \u0445\u043E\u0434\u0438\u0442\u0438 \u0442\u0430 \u0432\u0456\u0434\u0447\u0443\u0432\u0430\u0442\u0438 \u0430\u0442\u043C\u043E\u0441\u0444\u0435\u0440\u0443",
        'h3.3': "\u0424\u0406\u0422\u041D\u0415\u0421",
        'p.9': "\u041F\u043E\u0454\u0434\u043D\u0443\u0439\u0442\u0435 \u0431\u0456\u0437\u043D\u0435\u0441 \u0456\u0437 \u0437\u0430\u0434\u043E\u0432\u043E\u043B\u0435\u043D\u043D\u044F\u043C \u0456 \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0435\u0437\u043B\u0456\u0447\u0435\u043D\u043D\u0456 \u0441\u043F\u043E\u0441\u043E\u0431\u0438",
        'span.8': '...',
        'span.9': "\u0437\u0430\u043B\u0438\u0448\u0430\u0442\u0438\u0441\u044F \u0432 \u0444\u043E\u0440\u043C\u0456 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0433\u0440\u0438 \u0443 \u0432\u0430\u0448\u0456 \u0443\u043B\u044E\u0431\u043B\u0435\u043D\u0456 VR \u0456\u0433\u0440\u0438!",
        'h3.4': "\u0421\u041E\u0426\u0406\u0410\u041B\u042C\u041D\u0406 \u0412\u0417\u0410\u0404\u041C\u041E\u0414\u0406\u0407",
        'p.10': "\u041F\u0440\u043E\u0432\u043E\u0434\u044C\u0442\u0435 \u0447\u0430\u0441 \u0456\u0437 \u0434\u0440\u0443\u0437\u044F\u043C\u0438 \u0443 \u0432\u0456\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0441\u0432\u0456\u0442\u0456, \u043A\u043E\u043B\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435",
        'span.10': '...',
        'span.11': "\u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0441\u0442\u0456\u0440 \u0434\u043B\u044F \u0437\u0443\u0441\u0442\u0440\u0456\u0447\u0435\u0439",
        'h2.3': "\u041F\u0420\u041E",
        'span.12': "\u041F\u0420\u041E\u0414\u0423\u041A\u0422",
        'div.1': '1/5',
        'div.2': '2/5',
        'div.3': '3/5',
        'div.4': '4/5',
        'div.5': '5/5',
        'button.3': "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
        'button.4': "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        'div.6': "KAT loco \u2014 \u0446\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 VR \u043B\u043E\u043A\u043E\u043C\u043E\u0446\u0456\u0457, \u0449\u043E \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u044E\u0454\u0442\u044C\u0441\u044F \u043D\u0430 \u043D\u043E\u0433\u0438 \u0456 \u0434\u0430\u0454 \u043F\u043E\u0432\u043D\u0438\u0439 \u0444\u0456\u0437\u0438\u0447\u043D\u0438\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u043D\u0438\u0436\u043D\u044C\u043E\u0457 \u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0442\u0456\u043B\u0430, \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0447\u0438 \u0432\u0456\u043B\u044C\u043D\u043E \u0445\u043E\u0434\u0438\u0442\u0438, \u0431\u0456\u0433\u0430\u0442\u0438 \u0442\u0430 \u0432\u0438\u043A\u043E\u043D\u0443\u0432\u0430\u0442\u0438 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456 \u0456\u043D\u0448\u0456 \u0440\u0443\u0445\u0438 \u0443 \u0432\u0456\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0456\u0439 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0456.",
        'p.11': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0456\u0434\u0435\u043E",
        'div.7': "\u041F\u0440\u0438\u0432\u0456\u0442,",
        'h2.4': "\u0420\u0410\u0414\u0406 ",
        'span.13': "\u0417\u041D\u0410\u0419\u041E\u041C\u0421\u0422\u0412\u0423!",
        'div.8': "KAT VR \u2014 \u043D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044F, \u043F\u0440\u0438\u0441\u0432\u044F\u0447\u0435\u043D\u0430 \u0434\u043E\u0441\u043B\u0456\u0434\u0436\u0435\u043D\u043D\u044E, \u0440\u043E\u0437\u0440\u043E\u0431\u0446\u0456 \u0442\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432 VR \u043B\u043E\u043A\u043E\u043C\u043E\u0446\u0456\u0457 \u0442\u0430 \u0440\u0456\u0448\u0435\u043D\u044C. \u0417\u0430\u0441\u043D\u043E\u0432\u0430\u043D\u0430 \u0443 2013 \u0440\u043E\u0446\u0456, \u043C\u0438 \u0448\u0432\u0438\u0434\u043A\u043E \u0441\u0442\u0430\u043B\u0438 \u043E\u0434\u043D\u0438\u043C \u0456\u0437 \u043F\u0440\u043E\u0432\u0456\u0434\u043D\u0438\u0445 \u043F\u0440\u043E\u0444\u0435\u0441\u0456\u0439\u043D\u0438\u0445 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0456\u0432 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F VR \u0456\u0433\u043E\u0440 \u0442\u0430 \u0441\u0438\u043C\u0443\u043B\u044F\u0446\u0456\u0439 \u0443 \u0441\u0432\u0456\u0442\u0456.",
        'h2.5': "\u0422\u0415\u0425\u041D\u0406\u0427\u041D\u0406",
        'span.14': "\u0425\u0410\u0420\u0410\u041A\u0422\u0415\u0420\u0418\u0421\u0422\u0418\u041A\u0418",
        'h3.5': "\u0421\u0415\u041D\u0421\u041E\u0420",
        'p.12': "\u0412\u0430\u0433\u0430: 35\u0433/1.23\u0443\u043D\u0446\u0456\u0457 \u043A\u043E\u0436\u0435\u043D   \n   \u0420\u043E\u0437\u043C\u0456\u0440\u0438: 50\u043C\u043C/1.97\u0434\u044E\u0439\u043C\u0430 \u0445 24\u043C\u043C/0.94\u0434\u044E\u0439\u043C\u0430   \n   \u041F\u0456\u0434\u0441\u0432\u0456\u0442\u043A\u0430: \u0441\u0432\u0456\u0442\u043B\u043E\u0434\u0456\u043E\u0434\u043D\u0430",
        'h3.6': "\u0417\u2019\u0404\u0414\u041D\u0410\u041D\u041D\u042F",
        'p.13': "\u0411\u0435\u0437\u0434\u0440\u043E\u0442\u043E\u0432\u0435: Bluetooth 4.2   \n   \u0414\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044C: 5\u043C   \n   \u041F\u0440\u0438\u0439\u043C\u0430\u0447: USB 2.0 \u0442\u0430 \u0432\u0438\u0449\u0435",
        'h3.7': "\u0410\u041A\u0423\u041C\u0423\u041B\u042F\u0422\u041E\u0420\u0418",
        'p.14': "\u0422\u0438\u043F: \u043B\u0456\u0442\u0456\u0439-\u043F\u043E\u043B\u0456\u043C\u0435\u0440\u043D\u0456 \u0431\u0430\u0442\u0430\u0440\u0435\u0457    \n  \u0404\u043C\u043D\u0456\u0441\u0442\u044C: 370\u043C\u0410\u0433   \n   \u0427\u0430\u0441 \u0440\u043E\u0431\u043E\u0442\u0438: 10 \u0433\u043E\u0434\u0438\u043D \u0431\u0435\u0437\u043F\u0435\u0440\u0435\u0440\u0432\u043D\u043E, 150 \u0433\u043E\u0434\u0438\u043D \u0443 \u0440\u0435\u0436\u0438\u043C\u0456 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \n     \u0428\u0432\u0438\u0434\u043A\u0430 \u0437\u0430\u0440\u044F\u0434\u043A\u0430: 1 \u0433\u043E\u0434\u0438\u043D\u0430   \n   \u041D\u0430\u043F\u0440\u0443\u0433\u0430 \u0442\u0430 \u0441\u0442\u0440\u0443\u043C: 5\u0412 = 0.5\u0410",
        'h2.6': "\u0427\u041E\u041C\u0423",
        'span.15': 'KAT LOCO?',
        'h3.8': "\u0423\u0421\u0415\u0421\u0412\u0406\u0422\u041D\u042F \u0421\u0423\u041C\u0406\u0421\u041D\u0406\u0421\u0422\u042C",
        'p.15': "KAT Loco \u043F\u0440\u043E\u043F\u043E\u043D\u0443\u0454 \u0443\u043D\u0456\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0443 \u0441\u0443\u043C\u0456\u0441\u043D\u0456\u0441\u0442\u044C \u0437 \u0443\u0441\u0456\u043C\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u0438\u043C\u0438 VR \u0433\u0430\u0440\u043D\u0456\u0442\u0443\u0440\u0430\u043C\u0438 \u0442\u0430",
        'span.16': "\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u043C\u0438...",
        'span.17': '...',
        'span.18': "\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u043C\u0438, \u0449\u043E \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442\u044C \u0433\u0440\u0430\u0442\u0438 \u0443 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456 VR \u0456\u0433\u0440\u0438 \u0437 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u043E\u044E   \u0432\u0456\u043B\u044C\u043D\u043E\u0457 \u043B\u043E\u043A\u043E\u043C\u043E\u0446\u0456\u0457",
        'h3.9': "\u041F\u0410\u041D\u0415\u041B\u042C \u041A\u0415\u0420\u0423\u0412\u0410\u041D\u041D\u042F VR/PC",
        'p.16': "\u041D\u0430\u0448\u0435 \u0431\u0430\u0433\u0430\u0442\u043E\u0444\u0443\u043D\u043A\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u0435 \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u0448\u0432\u0438\u0434\u043A\u043E   \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u0442\u0438 \u0434\u043E \u043F\u0430\u043D\u0435\u043B\u0456 \u043A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F KAT Loco",
        'span.19': "\u044F\u043A \u0437 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0441\u0442\u043E\u043B\u0443...",
        'span.20': '...',
        'span.21': "\u044F\u043A \u0437 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0441\u0442\u043E\u043B\u0443, \u0442\u0430\u043A \u0456 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0437 \u0432\u0430\u0448\u043E\u0457 VR \u0433\u0430\u0440\u043D\u0456\u0442\u0443\u0440\u0438.",
        'h3.10': "\u0411\u0415\u0417\u0414\u0420\u041E\u0422\u041E\u0412\u0406 \u0421\u0415\u041D\u0421\u041E\u0420\u0418",
        'p.17': "\u0429\u0435 \u0431\u0456\u043B\u044C\u0448 \u043F\u0440\u043E\u0441\u0443\u043D\u0443\u0442\u043E, KAT Loco \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0431\u0435\u0437\u0434\u0440\u043E\u0442\u043E\u0432\u0438\u0439, \u0442\u0430",
        'span.22': "\u043F\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0437\u2026",
        'span.23': '...',
        'span.24': "\u043F\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0437 \u043F\u043E\u0432\u043D\u043E\u044E \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u044E \u0430\u043B\u0433\u043E\u0440\u0438\u0442\u043C\u0456\u0432, \u043D\u0430\u0434\u043C\u0456\u0446\u043D\u0438\u043C\u0438 \u0431\u0430\u0442\u0430\u0440\u0435\u044F\u043C\u0438 \u0456 \u0431\u0430\u0433\u0430\u0442\u043E \u0447\u0438\u043C \u0456\u043D\u0448\u0438\u043C!",
        'button.5': "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u0440\u0430\u0437",
        'p.18': "\u0404 \u043F\u0438\u0442\u0430\u043D\u043D\u044F?",
        'h2.7': "\u0417\u0412\u2019\u042F\u0416\u0406\u0422\u042C\u0421\u042F",
        'span.25': "\u0417 \u041D\u0410\u041C\u0418",
        'p.19': "\u041D\u0430\u0448 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0441\u0442\u044C \u0432\u0430\u043C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 15 \u0445\u0432\u0438\u043B\u0438\u043D",
        'a.16': '+86-0571-86105373',
        'a.17': 'global@katvr.com',
        'a.18': 'overseas@katvr.com',
        'label.1': "\u0406\u043C'\u044F*",
        'label.2': "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430*",
        'label.3': "\u0422\u0435\u043B\u0435\u0444\u043E\u043D*",
        'label.4': "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        'a.19': "\u041F\u0440\u043E \u043D\u0430\u0441",
        'a.20': "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0456\u0457",
        'a.21': "\u041F\u0435\u0440\u0435\u0432\u0430\u0433\u0438",
        'a.22': "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
        'a.23': '+86-0571-86105373',
        'a.24': 'global@katvr.com',
        'a.25': 'overseas@katvr.com'
    },
    de: {
        'title.1': 'KAT VR | Nr. 1 Innovator der VR-Laufbandtechnologie',
        'option.1': 'En',
        'option.2': 'Ua',
        'option.3': 'De',
        'a.1': "\xdcber uns",
        'a.2': 'Technik',
        'a.3': 'Vorteile',
        'a.4': 'Kontakt',
        'a.5': 'Sprache',
        'a.6': 'FAQ',
        'a.7': 'Hilfe',
        'li.1': 'Englisch',
        'li.2': 'Ukrainisch',
        'li.3': 'Deutsch',
        'h2.1': "WIE K\xd6NNEN WIR  IHNEN ",
        'span.1': 'HILFE ',
        'span.101': 'HELFEN?',
        'p.1': "Willkommen in unserem Help Center. Unser Ziel ist es, den Prozess des Kennenlernens und Kaufens so einfach und angenehm wie m\xf6glich zu gestalten. Ben\xf6tigen Sie Hilfe mit Ihrem KAT VR loco Produkt? Viele Fragen k\xf6nnen durch unsere Produktsupport-Seite beantwortet werden. ",
        'a.8': 'FAQs',
        'p.2': "Bitte z\xf6gern Sie nicht, uns direkt zu kontaktieren, falls Sie weitere Hilfe ben\xf6tigen. Wir helfen Ihnen gerne. ",
        'a.9': 'Kontaktieren Sie uns',
        'a.10': 'Bedienungsanleitung',
        'a.11': 'Garantie',
        'a.12': 'Servicebedingungen',
        'a.13': '+86-0571-86105373',
        'a.14': 'global@katvr.com',
        'a.15': 'overseas@katvr.com',
        'h1.1': 'DER NEUE START VON',
        'span.2': 'VR LOCOMOTION',
        'p.3': 'Entdecken Sie das umfassendste VR-Lokomotionssystem und entfesseln Sie unbegrenzte Bewegungen in allen Spielen und auf allen Plattformen!',
        'p.4': '1200$',
        'p.5': 'Video abspielen',
        'button.1': 'Jetzt kaufen',
        'button.2': 'Mehr',
        'h2.2': 'MEHR ALS',
        'span.3': 'GAMING!',
        'p.6': "Dies ist auch f\xfcr alle, die sich interessieren f\xfcr...",
        'h3.1': 'BILDUNG',
        'p.7': 'Erstellen Sie Ausbildungssimulationen, Schulungen und vieles mehr mit',
        'span.4': '...',
        'span.5': 'unbegrenztem virtuellem Raum und minimalem physischen Platz',
        'h3.2': 'IMMOBILIEN',
        'p.8': "Entwerfen Sie Architekturprojekte in einer \xe4u\xdferst realistischen Umgebung",
        'span.6': '...',
        'span.7': "und erm\xf6glichen Sie Besuchern, frei zu laufen und die Atmosph\xe4re zu sp\xfcren",
        'h3.3': 'FITNESS',
        'p.9': "Kombinieren Sie Gesch\xe4ft mit Vergn\xfcgen und entdecken Sie unz\xe4hlige M\xf6glichkeiten",
        'span.8': '...',
        'span.9': "fit zu bleiben, w\xe4hrend Sie Ihre Lieblings-VR-Spiele spielen!",
        'h3.4': 'SOZIALE INTERAKTIONEN',
        'p.10': 'Verbringen Sie Zeit mit Freunden in der virtuellen Welt, wenn Sie nicht',
        'span.10': '...',
        'span.11': "gen\xfcgend Platz f\xfcr Treffen haben",
        'h2.3': "\xdcBER",
        'span.12': 'PRODUKT',
        'div.1': '1/5',
        'div.2': '2/5',
        'div.3': '3/5',
        'div.4': '4/5',
        'div.5': '5/5',
        'button.3': "Zur\xfcck",
        'button.4': 'Weiter',
        'div.6': "KAT loco ist ein fu\xdfbasiertes VR-Lokomotionssystem, das vollst\xe4ndige physische Kontrolle \xfcber die Unterk\xf6rperbewegungen bietet und es Ihnen erm\xf6glicht, frei zu gehen, zu laufen und jede andere Bewegung in der virtuellen Realit\xe4t auszuf\xfchren.",
        'p.11': 'Video abspielen',
        'div.7': 'Hallo,',
        'h2.4': "SCH\xd6N KENNENZULERNEN",
        'span.13': 'SIE!',
        'div.8': "KAT VR ist ein unabh\xe4ngiges Unternehmen, das sich der Forschung, Entwicklung und dem Vertrieb von VR-Lokomotionsprodukten und -l\xf6sungen widmet. Gegr\xfcndet 2013, haben wir uns schnell zu einem der weltweit f\xfchrenden professionellen Anbieter von VR-Spiel- und Simulationsausstattung entwickelt.",
        'h2.5': 'TECHNISCHE',
        'span.14': 'DATEN',
        'h3.5': 'SENSOR',
        'p.12': "Gewicht: 35g/1,23oz pro St\xfcck   \n   Abmessungen: 50mm/1,97in 24mm/0,94in  \n    Beleuchtung: LED-Lichter",
        'h3.6': 'VERBINDUNG',
        'p.13': "Drahtlos: Bluetooth 4.2  \n    Reichweite: 5m   \n   Empf\xe4nger: USB 2.0 und h\xf6her",
        'h3.7': 'AKKUS',
        'p.14': "Typ: Lithium-Ionen-Polymer-Akkus   \n   Kapazit\xe4t: 370mAh  \n    Laufzeit: 10h Dauerbetrieb, 150h Standby   \n   Schnellladung: 1 Stunde    \n  Lade\xadspannung und \xadstrom: 5V = 0,5A",
        'h2.6': 'WARUM',
        'span.15': 'KAT LOCO?',
        'h3.8': 'UNIVERSALKOMPATIBEL',
        'p.15': "KAT Loco bietet universelle Kompatibilit\xe4t mit allen gro\xdfen VR-Headsets und",
        'span.16': 'Plattformen...',
        'span.17': '...',
        'span.18': "Plattformen, die Ihnen das Spielen jedes VR-Spiels mit Unterst\xfctzung f\xfcr freie Lokomotion erm\xf6glichen",
        'h3.9': 'VR/PC-STEUERPANEL',
        'p.16': "Unsere Multifunktionssoftware erm\xf6glicht schnellen Zugriff auf das KAT Loco Steuerpanel",
        'span.19': 'sowohl vom Desktop aus...',
        'span.20': '...',
        'span.21': 'sowohl vom Desktop als auch direkt von Ihrem VR-Headset aus.',
        'h3.10': 'DRAHTLOSE SENSOREN',
        'p.17': 'Was es noch fortschrittlicher macht, ist, dass KAT Loco komplett drahtlos ist und',
        'span.22': 'wird mit...',
        'span.23': '...',
        'span.24': 'geliefert mit einem kompletten System aus Algorithmen, super robusten Akkus und mehr!',
        'button.5': 'Jetzt kaufen',
        'p.18': 'Haben Sie Fragen?',
        'h2.7': 'NEHMEN SIE',
        'span.25': 'KONTAKT AUF',
        'p.19': 'Unser Manager antwortet Ihnen innerhalb von 15 Minuten',
        'a.16': '+86-0571-86105373',
        'a.17': 'global@katvr.com',
        'a.18': 'overseas@katvr.com',
        'label.1': 'Name*',
        'label.2': 'E-Mail*',
        'label.3': 'Telefon*',
        'label.4': 'Nachricht',
        'a.19': "\xdcber uns",
        'a.20': 'Technik',
        'a.21': 'Vorteile',
        'a.22': 'Kontakt',
        'a.23': '+86-0571-86105373',
        'a.24': 'global@katvr.com',
        'a.25': 'overseas@katvr.com'
    }
};
const burger = document.querySelector('.header__burger');
const nav = document.querySelector('.header__nav');
const closeBtn = document.querySelector('.header__nav-close');
const navBackground = document.querySelector('.header__background');
const newStartVideoDiv = document.querySelector('.new-start__video-container');
const newStartPlayVideoBtn = document.querySelector('.new-start__play-video-button');
const newStartCloseVideoBtn = document.querySelector('.new-start__video-close');
const aboutVideoDiv = document.querySelector('.about__video-container');
const aboutPlayVideoBtn = document.querySelector('.about__play-video-button');
const aboutCloseVideoBtn = document.querySelector('.about__video-close');
const hintButton1 = document.querySelector('.tech-specs__hint--1 .tech-specs__hint-button');
const hintButton2 = document.querySelector('.tech-specs__hint--2 .tech-specs__hint-button');
const hintButton3 = document.querySelector('.tech-specs__hint--3 .tech-specs__hint-button');
const hintText1 = document.querySelector('.tech-specs__hint--1 .tech-specs__hint-text');
const hintText2 = document.querySelector('.tech-specs__hint--2 .tech-specs__hint-text');
const hintText3 = document.querySelector('.tech-specs__hint--3 .tech-specs__hint-text');
const hintImage1 = document.querySelector('.tech-specs__hint--1 .tech-specs__hint-image');
const hintImage2 = document.querySelector('.tech-specs__hint--2 .tech-specs__hint-image');
const hintImage3 = document.querySelector('.tech-specs__hint--3 .tech-specs__hint-image');
const menuLangSelect = document.querySelector('.nav__select');
const menuLangButton = document.querySelector('.nav__item--lang');
const navList = document.querySelector('.nav__list');
const menuLangBack = document.querySelector('.nav__select-back');
const menuHelpButton = document.querySelector('.nav__item--help');
const menuHelpClose = document.querySelector('.help__close');
const menuHelp = document.querySelector('.help');
const menuHelpWrapper = document.querySelector('.help-wrapper');
const navLinks = document.querySelectorAll('header .nav__link, .help__link');
const langSelect = document.querySelector('.header__select-control');
const navLangOptions = document.querySelectorAll('.nav__select-option');
const navLangSelect = document.querySelector('.nav__select');
const aboutPrevBtn = document.querySelector('.about__prev-next .prev-next__prev');
const aboutNextBtn = document.querySelector('.about__prev-next .prev-next__next');
const aboutSlides = document.querySelectorAll('.about__slide');
const aboutDots = document.querySelectorAll('.about__dot');
const aboutUnderline = document.querySelector('.about__prev-next .prev-next__underline-position');
const newStartPrevBtn = document.querySelector('.new-start__prev-next .prev-next__prev');
const newStartNextBtn = document.querySelector('.new-start__prev-next .prev-next__next');
const newStartSlides = document.querySelectorAll('.new-start__image-wrapper');
const newStartUnderline = document.querySelector('.new-start__prev-next .prev-next__underline-position');
const slideshowContainer = document.querySelector('.about__slideshow-container');
let aboutIndex = 0;
let newStartIndex = 0;
let touchStartX = 0;
const THRESHOLD = 50;
function currentSlide(n) {
    if (n < 1) n = 1;
    if (n > aboutSlides.length) n = aboutSlides.length;
    Array.from(aboutSlides).forEach((s)=>s.style.display = 'none');
    Array.from(aboutDots).forEach((d)=>d.classList.remove('active'));
    aboutSlides[n - 1].style.display = 'block';
    aboutDots[n - 1].classList.add('about__dot--active');
}
function renderAbout() {
    aboutSlides.forEach((s)=>s.style.display = 'none');
    aboutDots.forEach((d)=>d.classList.remove('about__dot--active'));
    aboutSlides[aboutIndex].style.display = 'block';
    aboutDots[aboutIndex].classList.add('about__dot--active');
    aboutUnderline.style.left = `${aboutIndex * (100 / aboutSlides.length)}%`;
    aboutPrevBtn.classList.toggle('prev-next__prev--disabled', aboutIndex === 0);
    aboutNextBtn.classList.toggle('prev-next__next--disabled', aboutIndex === aboutSlides.length - 1);
}
aboutPrevBtn.addEventListener('click', ()=>{
    if (aboutIndex > 0) {
        aboutIndex--;
        renderAbout();
    }
});
aboutNextBtn.addEventListener('click', ()=>{
    if (aboutIndex < aboutSlides.length - 1) {
        aboutIndex++;
        renderAbout();
    }
});
function renderNewStart() {
    newStartSlides.forEach((s)=>s.style.display = 'none');
    newStartSlides[newStartIndex].style.display = 'block';
    newStartUnderline.style.left = `${newStartIndex * (100 / newStartSlides.length)}%`;
    newStartPrevBtn.classList.toggle('prev-next__prev--disabled', newStartIndex === 0);
    newStartNextBtn.classList.toggle('prev-next__next--disabled', newStartIndex === newStartSlides.length - 1);
}
newStartPrevBtn.addEventListener('click', ()=>{
    if (newStartIndex > 0) {
        newStartIndex--;
        renderNewStart();
    }
});
newStartNextBtn.addEventListener('click', ()=>{
    if (newStartIndex < newStartSlides.length - 1) {
        newStartIndex++;
        renderNewStart();
    }
});
function changeLanguage(lang) {
    const dict = translations[lang] || translations.en;
    document.querySelectorAll('[data-i18n]').forEach((el)=>{
        const key = el.dataset.i18n;
        const translation = dict[key] || translations.en[key] || '';
        if (el.children.length === 0) el.textContent = translation;
        else {
            const textNodes = Array.from(el.childNodes).filter((n)=>n.nodeType === Node.TEXT_NODE);
            const parts = translation.split(/\r?\n|\r|\n/g).map((s)=>s.trim());
            textNodes.forEach((node, idx)=>{
                node.nodeValue = parts[idx] || '';
            });
        }
    });
}
function onLangChange() {
    const newLang = langSelect.value;
    console.log(newLang);
    localStorage.setItem('lang', newLang);
    changeLanguage(newLang);
}
newStartPlayVideoBtn.addEventListener('click', ()=>{
    newStartVideoDiv.classList.add('new-start__video-container--open');
});
newStartCloseVideoBtn.addEventListener('click', ()=>{
    newStartVideoDiv.classList.remove('new-start__video-container--open');
});
aboutPlayVideoBtn.addEventListener('click', ()=>{
    aboutVideoDiv.classList.add('about__video-container--open');
});
aboutCloseVideoBtn.addEventListener('click', ()=>{
    aboutVideoDiv.classList.remove('about__video-container--open');
});
burger.addEventListener('click', ()=>{
    nav.classList.add('header__nav--open');
    document.body.style.overflowY = 'hidden';
    navBackground.classList.add('header__background--open');
});
closeBtn.addEventListener('click', ()=>{
    nav.classList.remove('header__nav--open');
    document.body.style.overflowY = 'auto';
    navBackground.classList.remove('header__background--open');
});
hintButton1.addEventListener('click', ()=>{
    if (hintText1.classList.contains('tech-specs__hint-text--open')) {
        hintText1.classList.remove('tech-specs__hint-text--open');
        hintButton1.classList.remove('tech-specs__hint-button--open');
        hintImage1.classList.remove('tech-specs__hint-image--open');
    } else {
        hintText1.classList.add('tech-specs__hint-text--open');
        hintButton1.classList.add('tech-specs__hint-button--open');
        hintImage1.classList.add('tech-specs__hint-image--open');
    }
});
hintButton2.addEventListener('click', ()=>{
    if (hintText2.classList.contains('tech-specs__hint-text--open')) {
        hintText2.classList.remove('tech-specs__hint-text--open');
        hintButton2.classList.remove('tech-specs__hint-button--open');
        hintImage2.classList.remove('tech-specs__hint-image--open');
    } else {
        hintText2.classList.add('tech-specs__hint-text--open');
        hintButton2.classList.add('tech-specs__hint-button--open');
        hintImage2.classList.add('tech-specs__hint-image--open');
    }
});
hintButton3.addEventListener('click', ()=>{
    if (hintText3.classList.contains('tech-specs__hint-text--open')) {
        hintText3.classList.remove('tech-specs__hint-text--open');
        hintButton3.classList.remove('tech-specs__hint-button--open');
        hintImage3.classList.remove('tech-specs__hint-image--open');
    } else {
        hintText3.classList.add('tech-specs__hint-text--open');
        hintButton3.classList.add('tech-specs__hint-button--open');
        hintImage3.classList.add('tech-specs__hint-image--open');
    }
});
menuLangButton.addEventListener('click', ()=>{
    menuLangSelect.classList.add('nav__select--open');
    navList.classList.add('nav__list--hidden');
});
menuLangBack.addEventListener('click', ()=>{
    menuLangSelect.classList.remove('nav__select--open');
    navList.classList.remove('nav__list--hidden');
});
menuHelpButton.addEventListener('click', ()=>{
    menuHelp.classList.add('help--open');
    menuHelpWrapper.classList.add('help-wrapper--open');
});
menuHelpClose.addEventListener('click', ()=>{
    menuHelp.classList.remove('help--open');
    menuHelpWrapper.classList.remove('help-wrapper--open');
    document.body.style.overflowY = 'auto';
});
navLinks.forEach((link)=>{
    if (link.innerText.trim() !== 'Help' && link.innerText.trim() !== 'Language') link.addEventListener('click', ()=>{
        nav.classList.remove('header__nav--open');
        menuHelp.classList.remove('help--open');
        navBackground.classList.remove('header__background--open');
        document.body.style.overflowY = 'auto';
        menuHelpWrapper.classList.remove('help-wrapper--open');
    });
    if (link.innerText.trim() === 'Help') link.addEventListener('click', ()=>{
        document.body.style.overflowY = 'hidden';
    });
});
navLangOptions.forEach((option)=>option.addEventListener('click', ()=>{
        const newLang = option.dataset.lang;
        localStorage.setItem('lang', newLang);
        changeLanguage(newLang);
        nav.classList.remove('header__nav--open');
        document.body.style.overflowY = 'auto';
        navBackground.classList.remove('header__background--open');
        navLangSelect.classList.remove('nav__select--open');
        navList.classList.remove('nav__list--hidden');
    }));
document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.querySelector('.contacts__form');
    const fields = Array.from(form.querySelectorAll('.contacts__field')).filter((element)=>Array.from(element.children).every((child)=>child.dataset.i18n !== 'label.4'));
    function validateField(fieldEl) {
        const input = fieldEl.querySelector('.contacts__input');
        const valid = input.checkValidity();
        const label = fieldEl.querySelector('.contacts__label');
        fieldEl.classList.remove('contacts__field--error', 'contacts__field--success');
        if (valid) {
            fieldEl.classList.add('contacts__field--success');
            label.textContent = label.dataset.text;
        } else {
            fieldEl.classList.add('contacts__field--error');
            label.textContent = label.dataset.error;
        }
        return valid;
    }
    fields.forEach((fieldEl)=>{
        const label = fieldEl.querySelector('.contacts__label');
        const input = fieldEl.querySelector('.contacts__input');
        input.addEventListener('blur', ()=>validateField(fieldEl));
        input.addEventListener('focus', ()=>label.textContent = label.dataset.text);
    });
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const allValid = fields.every((fieldEl)=>validateField(fieldEl));
        if (allValid) {
            alert('Form submitted successfully!');
            form.reset();
            fields.forEach((f)=>f.classList.remove('contacts__field--success'));
        }
    });
});
document.addEventListener('DOMContentLoaded', ()=>{
    const initial = 'en';
    langSelect.value = initial;
    changeLanguage(initial);
});
slideshowContainer.addEventListener('touchstart', (e)=>{
    touchStartX = e.touches[0].clientX;
});
slideshowContainer.addEventListener('touchend', (e)=>{
    const touchEndX = e.changedTouches[0].clientX;
    const diffX = touchEndX - touchStartX;
    if (Math.abs(diffX) < THRESHOLD) return;
    if (diffX > 0) {
        if (aboutIndex > 0) aboutIndex--;
    } else if (aboutIndex < aboutSlides.length - 1) aboutIndex++;
    renderAbout();
});
renderNewStart();
renderAbout();

//# sourceMappingURL=layout_KateVR.2fce569c.js.map
